var pubsYearFilter = jq('#publications-year-filter');
if (pubsYearFilter.length) {
    pubsYearFilter.change(function() {
        jq('.module-publications .content-box').removeClass('hide');
        var year = jq(this).val();
        if (year == '-1') {
            return;    
        }
        jq('.module-publications .content-box').each(function() {
            var box = jq(this);
            var boxYear = box.data('year');
            if (boxYear != year) {
                box.addClass('hide');    
            }
        });
    });
}

var pubsCategoryFilter = jq('#publications-category-filter');
if (pubsCategoryFilter.length) {
    pubsCategoryFilter.change(function() {
        jq('.module-publications .content-box').removeClass('hide');
        var category = jq(this).val();
        if (category == '-1') {
            return;    
        }
        jq('.module-publications .content-box').each(function() {
            var box = jq(this);
            var boxCategory = box.data('category');
            if (boxCategory != category) {
                box.addClass('hide');    
            }
        });
    });
}

// Open dialog for outbound/external links
jq('a').not('.fancybox, [data-fancybox], .thickbox').click(function(e) {
    var href = jq(this).attr('href');
    
    if (
    href != undefined && 
    href.indexOf('http') >= 0 && 
    href.indexOf('diamedica') < 0 &&
    href.indexOf('equisolve') < 0 &&
    href.indexOf('eqcdn.com') < 0 
    ) {
        e.preventDefault();
        var answer = confirm('You are about to leave the DiaMedica Therapeutics website. We are not responsible for the accuracy or content of information contained on any third-party websites nor do we necessarily monitor or endorse such websites. If you would like to leave this website and visit the third-party website please select OK.');
        if (answer) {
            window.open(href);
        } else {
            return false;
        }
    }
});